import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "mt-5 pt-5 ps-3",
  "aria-label": "breadcrumb"
}
const _hoisted_2 = { class: "breadcrumb mb-3" }
const _hoisted_3 = { class: "breadcrumb-item" }
const _hoisted_4 = { class: "breadcrumb-item" }
const _hoisted_5 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_6 = { class: "row mb-4" }
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "card bg-primary text-white border-0 shadow-sm" }
const _hoisted_9 = { class: "card-body d-flex align-items-center p-4" }
const _hoisted_10 = ["src"]
const _hoisted_11 = {
  key: 1,
  class: "rounded-circle bg-white text-primary d-flex align-items-center justify-content-center me-4",
  style: {"width":"100px","height":"100px"}
}
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = { class: "mb-0 opacity-75" }
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = { class: "badge bg-light text-dark" }
const _hoisted_16 = { class: "row mb-4" }
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "card border-0 shadow-sm text-center p-3" }
const _hoisted_19 = { class: "text-primary" }
const _hoisted_20 = { class: "col-md-3" }
const _hoisted_21 = { class: "card border-0 shadow-sm text-center p-3" }
const _hoisted_22 = { class: "text-success" }
const _hoisted_23 = { class: "col-md-3" }
const _hoisted_24 = { class: "card border-0 shadow-sm text-center p-3" }
const _hoisted_25 = { class: "text-info" }
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = { class: "card border-0 shadow-sm text-center p-3" }
const _hoisted_28 = { class: "text-warning" }
const _hoisted_29 = { class: "row" }
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "card border-0 shadow-sm" }
const _hoisted_32 = { class: "card-header bg-white" }
const _hoisted_33 = {
  class: "nav nav-tabs card-header-tabs",
  role: "tablist"
}
const _hoisted_34 = { class: "nav-item" }
const _hoisted_35 = { class: "nav-item" }
const _hoisted_36 = { class: "nav-item" }
const _hoisted_37 = { class: "card-body p-4" }
const _hoisted_38 = { key: 0 }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = { class: "col-md-6" }
const _hoisted_41 = { class: "table table-sm mt-3" }
const _hoisted_42 = { class: "col-md-6 border-start" }
const _hoisted_43 = { class: "table table-sm mt-3" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "table-responsive" }
const _hoisted_47 = { class: "table table-hover" }
const _hoisted_48 = { class: "d-flex align-items-center" }
const _hoisted_49 = ["src"]
const _hoisted_50 = { class: "badge bg-light text-dark" }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 2 }
const _hoisted_53 = { class: "row g-3" }
const _hoisted_54 = { class: "card h-100 border shadow-none" }
const _hoisted_55 = { class: "card-body" }
const _hoisted_56 = { class: "d-flex justify-content-between align-items-start mb-2" }
const _hoisted_57 = { class: "mb-0" }
const _hoisted_58 = { class: "small text-muted mb-3" }
const _hoisted_59 = { class: "d-flex justify-content-between align-items-center mt-auto" }
const _hoisted_60 = { class: "text-muted" }
const _hoisted_61 = {
  key: 0,
  class: "col-12 text-center py-5 text-muted"
}
const _hoisted_62 = {
  key: 1,
  class: "container-fluid text-center py-5"
}
const _hoisted_63 = {
  key: 2,
  class: "container-fluid py-5"
}
const _hoisted_64 = { class: "alert alert-danger text-center" }
const _hoisted_65 = { class: "mt-3" }

import { ref, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import apiService from '@/services/apiService';


export default /*@__PURE__*/_defineComponent({
  __name: 'CompanyDetails',
  setup(__props) {

const route = useRoute();
const companyId = route.params.id as string;

const company = ref<any>(null);
const members = ref<any[]>([]);
const workspaces = ref<any[]>([]);
const isLoading = ref(true);
const error = ref<string | null>(null);
const activeTab = ref('general');

const loadData = async () => {
  isLoading.value = true;
  try {
    const [companyRes, membersRes, workspacesRes] = await Promise.all([
      apiService.getCompanyById(companyId),
      apiService.getCompanyMembers(companyId),
      apiService.getCompanyWorkspaces(companyId)
    ]);

    company.value = companyRes;
    members.value = Array.isArray(membersRes) ? membersRes : (membersRes.data || []);
    workspaces.value = Array.isArray(workspacesRes) ? workspacesRes : (workspacesRes.data || []);
  } catch (err: any) {
    error.value = err.message || 'Failed to load company data';
    console.error(err);
  } finally {
    isLoading.value = false;
  }
};

const formatDate = (dateString: string) => {
  if (!dateString) return '-';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
};

const formatTimeAgo = (dateString: string) => {
  if (!dateString) return 'Never';
  const date = new Date(dateString);
  const now = new Date();
  const diffInDays = Math.floor((now.getTime() - date.getTime()) / (1000 * 3600 * 24));
  if (diffInDays === 0) return 'Today';
  if (diffInDays === 1) return 'Yesterday';
  return `${diffInDays} days ago`;
};

const getStatusBadge = (status: string) => {
  if (!status) return '';
  switch (status.toLowerCase()) {
    case 'active': return 'border-success text-success';
    case 'inactive': return 'border-warning text-warning';
    case 'suspended': return 'border-danger text-danger';
    default: return 'border-secondary text-secondary';
  }
};

onMounted(() => {
  loadData();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("ol", _hoisted_2, [
        _createElementVNode("li", _hoisted_3, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("li", _hoisted_4, [
          _createVNode(_component_router_link, { to: "/admin/companies" }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("Companies", -1)
            ]))]),
            _: 1
          })
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("li", {
          class: "breadcrumb-item active",
          "aria-current": "page"
        }, "Company Details", -1))
      ])
    ]),
    (company.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (company.value.logo)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: company.value.logo,
                        class: "rounded-circle border border-white border-4 me-4",
                        style: {"width":"100px","height":"100px","object-fit":"cover"}
                      }, null, 8, _hoisted_10))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("i", { class: "fa fa-building fa-3x" }, null, -1)
                      ]))])),
                  _createElementVNode("div", null, [
                    _createElementVNode("h2", _hoisted_12, _toDisplayString(company.value.title), 1),
                    _createElementVNode("p", _hoisted_13, [
                      _cache[7] || (_cache[7] = _createElementVNode("i", { class: "fa fa-link me-1" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(company.value.slug) + " | ", 1),
                      _cache[8] || (_cache[8] = _createElementVNode("i", { class: "fa fa-users me-1" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(company.value.company_size) + " Employees | ", 1),
                      _cache[9] || (_cache[9] = _createElementVNode("i", { class: "fa fa-calendar me-1" }, null, -1)),
                      _createTextVNode(" Joined " + _toDisplayString(formatDate(company.value.createdAt)), 1)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("span", {
                        class: _normalizeClass(['badge bg-light text-dark me-2', getStatusBadge(company.value.status)])
                      }, " Status: " + _toDisplayString(company.value.status), 3),
                      _createElementVNode("span", _hoisted_15, " Billing: " + _toDisplayString(company.value.billing_status), 1)
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h3", _hoisted_19, _toDisplayString(members.value.length), 1),
                _cache[10] || (_cache[10] = _createElementVNode("small", { class: "text-muted text-uppercase fw-bold" }, "Members", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("h3", _hoisted_22, _toDisplayString(workspaces.value.length), 1),
                _cache[11] || (_cache[11] = _createElementVNode("small", { class: "text-muted text-uppercase fw-bold" }, "Workspaces", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h3", _hoisted_25, _toDisplayString(company.value.settings?.max_workspaces || '∞'), 1),
                _cache[12] || (_cache[12] = _createElementVNode("small", { class: "text-muted text-uppercase fw-bold" }, "Max Workspaces", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("h3", _hoisted_28, _toDisplayString(formatTimeAgo(company.value.last_activity_at)), 1),
                _cache[13] || (_cache[13] = _createElementVNode("small", { class: "text-muted text-uppercase fw-bold" }, "Last Active", -1))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("ul", _hoisted_33, [
                    _createElementVNode("li", _hoisted_34, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: activeTab.value === 'general' }]),
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (activeTab.value = 'general'))
                      }, "General Info", 2)
                    ]),
                    _createElementVNode("li", _hoisted_35, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: activeTab.value === 'members' }]),
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (activeTab.value = 'members'))
                      }, "Members (" + _toDisplayString(members.value.length) + ")", 3)
                    ]),
                    _createElementVNode("li", _hoisted_36, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["nav-link", { active: activeTab.value === 'workspaces' }]),
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (activeTab.value = 'workspaces'))
                      }, "Workspaces (" + _toDisplayString(workspaces.value.length) + ")", 3)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  (activeTab.value === 'general')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _cache[18] || (_cache[18] = _createElementVNode("h6", null, "Company Information", -1)),
                            _createElementVNode("table", _hoisted_41, [
                              _createElementVNode("tr", null, [
                                _cache[14] || (_cache[14] = _createElementVNode("td", {
                                  class: "fw-bold text-muted",
                                  style: {"width":"150px"}
                                }, "Title:", -1)),
                                _createElementVNode("td", null, _toDisplayString(company.value.title), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "fw-bold text-muted" }, "Slug:", -1)),
                                _createElementVNode("td", null, [
                                  _createElementVNode("code", null, _toDisplayString(company.value.slug), 1)
                                ])
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "fw-bold text-muted" }, "Owner ID:", -1)),
                                _createElementVNode("td", null, _toDisplayString(company.value.owner_id), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[17] || (_cache[17] = _createElementVNode("td", { class: "fw-bold text-muted" }, "Size:", -1)),
                                _createElementVNode("td", null, _toDisplayString(company.value.company_size), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _cache[23] || (_cache[23] = _createElementVNode("h6", null, "Lifecycle & Billing", -1)),
                            _createElementVNode("table", _hoisted_43, [
                              _createElementVNode("tr", null, [
                                _cache[19] || (_cache[19] = _createElementVNode("td", {
                                  class: "fw-bold text-muted",
                                  style: {"width":"150px"}
                                }, "Status:", -1)),
                                _createElementVNode("td", null, _toDisplayString(company.value.status), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[20] || (_cache[20] = _createElementVNode("td", { class: "fw-bold text-muted" }, "Billing Status:", -1)),
                                _createElementVNode("td", null, _toDisplayString(company.value.billing_status), 1)
                              ]),
                              _createElementVNode("tr", null, [
                                _cache[21] || (_cache[21] = _createElementVNode("td", { class: "fw-bold text-muted" }, "Active:", -1)),
                                _createElementVNode("td", null, _toDisplayString(company.value.is_active ? 'Yes' : 'No'), 1)
                              ]),
                              (!company.value.is_active)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_44, [
                                    _cache[22] || (_cache[22] = _createElementVNode("td", { class: "fw-bold text-muted" }, "Deactivated At:", -1)),
                                    _createElementVNode("td", null, _toDisplayString(company.value.deactivated_at ? formatDate(company.value.deactivated_at) : '-'), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (activeTab.value === 'members')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createElementVNode("div", _hoisted_46, [
                          _createElementVNode("table", _hoisted_47, [
                            _cache[25] || (_cache[25] = _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", null, "User"),
                                _createElementVNode("th", null, "Email"),
                                _createElementVNode("th", null, "Role"),
                                _createElementVNode("th", null, "Joined")
                              ])
                            ], -1)),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(members.value, (member) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                  key: member._id
                                }, [
                                  _createElementVNode("td", null, [
                                    _createElementVNode("div", _hoisted_48, [
                                      _createElementVNode("img", {
                                        src: member.avatar || 'https://ui-avatars.com/api/?name='+member.name,
                                        class: "rounded-circle me-2",
                                        style: {"width":"30px","height":"30px"}
                                      }, null, 8, _hoisted_49),
                                      _createTextVNode(" " + _toDisplayString(member.name), 1)
                                    ])
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(member.email), 1),
                                  _createElementVNode("td", null, [
                                    _createElementVNode("span", _hoisted_50, _toDisplayString(member.company_role || 'Member'), 1)
                                  ]),
                                  _createElementVNode("td", null, _toDisplayString(formatDate(member.createdAt)), 1)
                                ]))
                              }), 128)),
                              (members.value.length === 0)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_51, [...(_cache[24] || (_cache[24] = [
                                    _createElementVNode("td", {
                                      colspan: "4",
                                      class: "text-center py-4 text-muted"
                                    }, "No members found", -1)
                                  ]))]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (activeTab.value === 'workspaces')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                        _createElementVNode("div", _hoisted_53, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(workspaces.value, (ws) => {
                            return (_openBlock(), _createElementBlock("div", {
                              class: "col-md-4",
                              key: ws._id
                            }, [
                              _createElementVNode("div", _hoisted_54, [
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("div", _hoisted_56, [
                                    _createElementVNode("h6", _hoisted_57, _toDisplayString(ws.title), 1),
                                    _createElementVNode("span", {
                                      class: _normalizeClass(['badge small', ws.is_active ? 'bg-success' : 'bg-secondary'])
                                    }, _toDisplayString(ws.is_active ? 'Active' : 'Inactive'), 3)
                                  ]),
                                  _createElementVNode("p", _hoisted_58, _toDisplayString(ws.description || 'No description provided.'), 1),
                                  _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("small", _hoisted_60, [
                                      _cache[26] || (_cache[26] = _createElementVNode("i", { class: "fa fa-users me-1" }, null, -1)),
                                      _createTextVNode(" " + _toDisplayString(ws.memberCount || 0) + " members", 1)
                                    ]),
                                    _cache[27] || (_cache[27] = _createElementVNode("button", { class: "btn btn-sm btn-link text-primary p-0" }, "View Details", -1))
                                  ])
                                ])
                              ])
                            ]))
                          }), 128)),
                          (workspaces.value.length === 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_61, " No workspaces found for this company. "))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : (isLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_62, [...(_cache[28] || (_cache[28] = [
            _createElementVNode("div", {
              class: "spinner-border text-primary",
              role: "status"
            }, [
              _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
            ], -1),
            _createElementVNode("p", { class: "mt-2 text-muted" }, "Fetching company details...", -1)
          ]))]))
        : (_openBlock(), _createElementBlock("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _cache[30] || (_cache[30] = _createElementVNode("i", { class: "fa fa-exclamation-triangle me-2" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(error.value || 'Company not found') + " ", 1),
              _createElementVNode("div", _hoisted_65, [
                _createVNode(_component_router_link, {
                  to: "/admin/companies",
                  class: "btn btn-outline-danger"
                }, {
                  default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                    _createTextVNode("Back to Companies", -1)
                  ]))]),
                  _: 1
                })
              ])
            ])
          ]))
  ]))
}
}

})